module.exports = __webpack_public_path__ + "static/Anbaugebiet-Pfalz-800x1167-cf57346112fa81633a14bca975ff6ed8.jpeg";